<zui-tip-card
  class="__non-ha-card"
  [theme]="'warning'"
  [icon]="'fmd_bad'"
  [iconAlignment]="'end'"
  [iconSpacing]="90">

  <h4 class="__non-ha-title">{{ translations?.nonHaTitle }}</h4>

  <zui-docs-text>
    <div [innerHTML]="translations?.nonHaDesc | safeHtml"></div>
  </zui-docs-text>

</zui-tip-card>

<zui-separator
  [orientation]="'vertical'"
  [size]="'medium'"
  [spacing]="'large'"
  [position]="'center'"
/>

<zui-form-section
  [isZen]="isZen"
  [separator]="'none'">

  <span *zuiFormSectionTitle>
    {{ translations?.nameTitle }}
  </span>

  <div
    *zuiFormSectionDesc
    [innerHTML]="translations?.nameDesc">
  </div>

  <zef-form-field last>
    <zef-form-field>
      <z-hostname-field
        [label]="translations?.nameLabel"
        [placeholder]="translations?.namePlaceholder"
        [control]="state?.controls.name">
      </z-hostname-field>
    </zef-form-field>
  </zef-form-field>

</zui-form-section>

<zui-separator
  [orientation]="'vertical'"
  [size]="'medium'"
  [spacing]="'large'"
  [position]="'center'"
/>

<zui-form-section
  [isZen]="isZen"
  [separator]="'none'"
  class="__scaling-section">

  <span *zuiFormSectionTitle>
    {{ translations?.scalingTitle }}
  </span>

  <div *zuiFormSectionDesc>
    <zui-docs-text>
      <span [innerHTML]="translations?.scalingDesc | safeHtml"></span>
    </zui-docs-text>
  </div>

  <zef-form-field>
    <zui-autoscaling-form-field
      [serviceStackType]="serviceStackType"
      [ngrxFormControlState]="state?.controls.customAutoscaling"
      [supportsVerticalAutoscaling]="supportsVerticalAutoscaling"
      [defaultHorizontalAutoscaling]="defaultHorizontalAutoscaling"
      [defaultVerticalAutoscaling]="defaultVerticalAutoscaling"
      [horizontalPlaceholder]="horizontalPlaceholder"
      [verticalPlaceholder]="verticalPlaceholder"
      [autoscalingProfiles]="autoscalingProfiles"
      [isFreeUser]="isFreeUser">
    </zui-autoscaling-form-field>
  </zef-form-field>

</zui-form-section>
